var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 407.3273,
    viewBox: "0 0 132.29165 107.77201",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(5.21984e-6,-189.22787)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 36.777084,
    y: 111.2625,
    id: "text12"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan14",
    x: 36.777084,
    y: 121.05208
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 66.410416,
    y: 130.04791,
    id: "text18"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan16",
    x: 66.410416,
    y: 139.83749,
    style: {
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D2",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "360.46774292px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 9.011693
    },
    id: "text22"
  }, /*#__PURE__*/React.createElement("g", {
    "aria-label": "\\uE1D7 \\uE1D5 \\uE1E7",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.38434362
    },
    id: "text4179",
    transform: "matrix(12.52544,0,0,12.52544,-290.57755,-2944.4561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 27.019575,252.56679 c -0.433917,-0.66675 -0.79375,-1.36525 -0.92075,-2.18016 -0.03175,-0.13759 -0.09525,-0.17992 -0.254,-0.17992 -0.04233,0 -0.08467,0.0106 -0.08467,0.0741 v 0.0106 c 0,0 0,0.0212 0,0.0423 v 1.98967 c 0,0 0,0 0,0 v 4.27566 c -0.169333,-0.14816 -0.402166,-0.22225 -0.677333,-0.22225 -1.04775,0 -1.883833,0.77259 -1.883833,1.5875 0,0.49742 0.402166,0.79375 0.92075,0.79375 0.846666,0 1.894416,-0.78316 1.894416,-1.5875 v -4.75191 c 0.518584,0.32808 1.143,1.25941 1.407584,1.87325 0.127,0.28575 0.201083,0.77258 0.201083,1.27 0,0.381 -0.05292,0.78316 -0.201083,1.16416 -0.01058,0.0423 -0.02117,0.0847 -0.02117,0.127 0,0.127 0.08467,0.21167 0.137583,0.24342 l 0.01058,0.0106 c 0.07408,0 0.179916,-0.0317 0.22225,-0.16933 0,0 0.22225,-0.80433 0.22225,-1.47108 0,-1.05834 -0.4445,-2.05317 -0.973667,-2.89984 z",
    style: {
      strokeWidth: 2.38434362
    },
    id: "path4181"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 31.60993,256.62021 c -0.169333,-0.14817 -0.402166,-0.22225 -0.677333,-0.22225 -1.04775,0 -1.883833,0.77258 -1.883833,1.59808 0,0.49742 0.402166,0.79375 0.92075,0.79375 0.846666,0 1.894416,-0.79375 1.894416,-1.59808 v -7.00617 h -0.254 z",
    style: {
      strokeWidth: 2.38434362
    },
    id: "path4183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 33.760827,257.59388 c 0,-0.23284 -0.1905,-0.42334 -0.423333,-0.42334 -0.232833,0 -0.423333,0.1905 -0.423333,0.42334 0,0.23283 0.1905,0.42333 0.423333,0.42333 0.232833,0 0.423333,-0.1905 0.423333,-0.42333 z",
    style: {
      strokeWidth: 2.38434362
    },
    id: "path4185"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqd);
export default __webpack_public_path__ + "static/media/eqd.3836088d77703d288608bdfcd7e44d49.svg";
export { ForwardRef as ReactComponent };